import { mapConfig } from "./map-config";

/**
 * Find if scaling keeps the map in bounds
 * @param scale [number]
 */
export const isInBounds = (scale: number) => {
  // If new zoom causes the width to be smaller than the window
  if (mapConfig.width * scale <= window.innerWidth) {
    return false;
  }
  // If new zoom causes the height to be smaller than the window
  if (mapConfig.height * scale <= window.innerHeight) {
    return false;
  }

  // Otherwise in bounds
  return true;
};
